/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  DefaultLanguageInfo,
  ErrorResponse,
  FormDefinitionResponse,
  FormSubmissionRequest,
  FormSubmissionResponse,
  FormsErrorResponse,
  FormsListResponse,
  GetContentItemsV1Params,
  GetFormDefinitionV1Params,
  GetFormsV1Params,
  IApiContentResponseModel,
  LanguageInfo,
  PagedIApiContentResponseModel,
  SearchContentV1Params,
  TranslationErrorResponse,
  TranslationResponse
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getContentItemsV1Response200 = {
  data: PagedIApiContentResponseModel
  status: 200
}

export type getContentItemsV1ResponseSuccess = (getContentItemsV1Response200) & {
  headers: Headers;
};
;

export type getContentItemsV1Response = (getContentItemsV1ResponseSuccess)

export const getGetContentItemsV1Url = (instanceId: string,
    params: GetContentItemsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter","sort"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${instanceId}/content?${stringifiedParams}` : `/api/v1/${instanceId}/content`
}

export const getContentItemsV1 = async (instanceId: string,
    params: GetContentItemsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getContentItemsV1Response> => {

  return customFetch<getContentItemsV1Response>(getGetContentItemsV1Url(instanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getContentByRouteV1Response200 = {
  data: IApiContentResponseModel
  status: 200
}

export type getContentByRouteV1Response404 = {
  data: ErrorResponse
  status: 404
}

export type getContentByRouteV1ResponseSuccess = (getContentByRouteV1Response200) & {
  headers: Headers;
};
export type getContentByRouteV1ResponseError = (getContentByRouteV1Response404) & {
  headers: Headers;
};

export type getContentByRouteV1Response = (getContentByRouteV1ResponseSuccess | getContentByRouteV1ResponseError)

export const getGetContentByRouteV1Url = (instanceId: string,
    route: string,) => {




  return `/api/v1/${instanceId}/content/item/${route}`
}

export const getContentByRouteV1 = async (instanceId: string,
    route: string, options?: Parameters<typeof customFetch>[1]): Promise<getContentByRouteV1Response> => {

  return customFetch<getContentByRouteV1Response>(getGetContentByRouteV1Url(instanceId,route),
  {
    ...options,
    method: 'GET'


  }
);}


export type getContentByIdV1Response200 = {
  data: IApiContentResponseModel
  status: 200
}

export type getContentByIdV1Response404 = {
  data: ErrorResponse
  status: 404
}

export type getContentByIdV1ResponseSuccess = (getContentByIdV1Response200) & {
  headers: Headers;
};
export type getContentByIdV1ResponseError = (getContentByIdV1Response404) & {
  headers: Headers;
};

export type getContentByIdV1Response = (getContentByIdV1ResponseSuccess | getContentByIdV1ResponseError)

export const getGetContentByIdV1Url = (instanceId: string,
    id: string,) => {




  return `/api/v1/${instanceId}/content/item/${id}`
}

export const getContentByIdV1 = async (instanceId: string,
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<getContentByIdV1Response> => {

  return customFetch<getContentByIdV1Response>(getGetContentByIdV1Url(instanceId,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type getContentByIdsV1Response200 = {
  data: IApiContentResponseModel[]
  status: 200
}

export type getContentByIdsV1Response400 = {
  data: ErrorResponse
  status: 400
}

export type getContentByIdsV1ResponseSuccess = (getContentByIdsV1Response200) & {
  headers: Headers;
};
export type getContentByIdsV1ResponseError = (getContentByIdsV1Response400) & {
  headers: Headers;
};

export type getContentByIdsV1Response = (getContentByIdsV1ResponseSuccess | getContentByIdsV1ResponseError)

export const getGetContentByIdsV1Url = (instanceId: string,) => {




  return `/api/v1/${instanceId}/content/items`
}

export const getContentByIdsV1 = async (instanceId: string, options?: Parameters<typeof customFetch>[1]): Promise<getContentByIdsV1Response> => {

  return customFetch<getContentByIdsV1Response>(getGetContentByIdsV1Url(instanceId),
  {
    ...options,
    method: 'GET'


  }
);}


export type getNavigationItemsV1Response200 = {
  data: unknown
  status: 200
}

export type getNavigationItemsV1ResponseSuccess = (getNavigationItemsV1Response200) & {
  headers: Headers;
};
;

export type getNavigationItemsV1Response = (getNavigationItemsV1ResponseSuccess)

export const getGetNavigationItemsV1Url = (instanceId: string,) => {




  return `/api/v1/${instanceId}/content/navigation`
}

export const getNavigationItemsV1 = async (instanceId: string, options?: Parameters<typeof customFetch>[1]): Promise<getNavigationItemsV1Response> => {

  return customFetch<getNavigationItemsV1Response>(getGetNavigationItemsV1Url(instanceId),
  {
    ...options,
    method: 'GET'


  }
);}


export type getFormsV1Response200 = {
  data: FormsListResponse
  status: 200
}

export type getFormsV1ResponseSuccess = (getFormsV1Response200) & {
  headers: Headers;
};
;

export type getFormsV1Response = (getFormsV1ResponseSuccess)

export const getGetFormsV1Url = (instanceId: string,
    params?: GetFormsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${instanceId}/forms?${stringifiedParams}` : `/api/v1/${instanceId}/forms`
}

export const getFormsV1 = async (instanceId: string,
    params?: GetFormsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getFormsV1Response> => {

  return customFetch<getFormsV1Response>(getGetFormsV1Url(instanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getFormDefinitionV1Response200 = {
  data: FormDefinitionResponse
  status: 200
}

export type getFormDefinitionV1Response404 = {
  data: FormsErrorResponse
  status: 404
}

export type getFormDefinitionV1ResponseSuccess = (getFormDefinitionV1Response200) & {
  headers: Headers;
};
export type getFormDefinitionV1ResponseError = (getFormDefinitionV1Response404) & {
  headers: Headers;
};

export type getFormDefinitionV1Response = (getFormDefinitionV1ResponseSuccess | getFormDefinitionV1ResponseError)

export const getGetFormDefinitionV1Url = (instanceId: string,
    formId: string,
    params?: GetFormDefinitionV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${instanceId}/forms/${formId}?${stringifiedParams}` : `/api/v1/${instanceId}/forms/${formId}`
}

export const getFormDefinitionV1 = async (instanceId: string,
    formId: string,
    params?: GetFormDefinitionV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getFormDefinitionV1Response> => {

  return customFetch<getFormDefinitionV1Response>(getGetFormDefinitionV1Url(instanceId,formId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type submitFormEntryV1Response202 = {
  data: FormSubmissionResponse
  status: 202
}

export type submitFormEntryV1Response400 = {
  data: FormsErrorResponse
  status: 400
}

export type submitFormEntryV1Response422 = {
  data: FormsErrorResponse
  status: 422
}

export type submitFormEntryV1ResponseSuccess = (submitFormEntryV1Response202) & {
  headers: Headers;
};
export type submitFormEntryV1ResponseError = (submitFormEntryV1Response400 | submitFormEntryV1Response422) & {
  headers: Headers;
};

export type submitFormEntryV1Response = (submitFormEntryV1ResponseSuccess | submitFormEntryV1ResponseError)

export const getSubmitFormEntryV1Url = (instanceId: string,
    formId: string,) => {




  return `/api/v1/${instanceId}/forms/${formId}/entries`
}

export const submitFormEntryV1 = async (instanceId: string,
    formId: string,
    formSubmissionRequest: FormSubmissionRequest, options?: Parameters<typeof customFetch>[1]): Promise<submitFormEntryV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<submitFormEntryV1Response>(getSubmitFormEntryV1Url(instanceId,formId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(formSubmissionRequest)
  }
);}


export type getLanguagesV1Response200 = {
  data: LanguageInfo[]
  status: 200
}

export type getLanguagesV1Response500 = {
  data: void
  status: 500
}

export type getLanguagesV1ResponseSuccess = (getLanguagesV1Response200) & {
  headers: Headers;
};
export type getLanguagesV1ResponseError = (getLanguagesV1Response500) & {
  headers: Headers;
};

export type getLanguagesV1Response = (getLanguagesV1ResponseSuccess | getLanguagesV1ResponseError)

export const getGetLanguagesV1Url = (instanceId: string,) => {




  return `/api/v1/${instanceId}/languages`
}

/**
 * Returns all configured languages/cultures from the specified CMS instance
 * @summary Get all languages for a CMS instance
 */
export const getLanguagesV1 = async (instanceId: string, options?: Parameters<typeof customFetch>[1]): Promise<getLanguagesV1Response> => {

  return customFetch<getLanguagesV1Response>(getGetLanguagesV1Url(instanceId),
  {
    ...options,
    method: 'GET'


  }
);}


export type getDefaultLanguageV1Response200 = {
  data: DefaultLanguageInfo
  status: 200
}

export type getDefaultLanguageV1Response404 = {
  data: void
  status: 404
}

export type getDefaultLanguageV1Response500 = {
  data: void
  status: 500
}

export type getDefaultLanguageV1ResponseSuccess = (getDefaultLanguageV1Response200) & {
  headers: Headers;
};
export type getDefaultLanguageV1ResponseError = (getDefaultLanguageV1Response404 | getDefaultLanguageV1Response500) & {
  headers: Headers;
};

export type getDefaultLanguageV1Response = (getDefaultLanguageV1ResponseSuccess | getDefaultLanguageV1ResponseError)

export const getGetDefaultLanguageV1Url = (instanceId: string,) => {




  return `/api/v1/${instanceId}/languages/default`
}

/**
 * Returns the default language/culture from the specified CMS instance
 * @summary Get default language for a CMS instance
 */
export const getDefaultLanguageV1 = async (instanceId: string, options?: Parameters<typeof customFetch>[1]): Promise<getDefaultLanguageV1Response> => {

  return customFetch<getDefaultLanguageV1Response>(getGetDefaultLanguageV1Url(instanceId),
  {
    ...options,
    method: 'GET'


  }
);}


export type searchContentV1Response200 = {
  data: void
  status: 200
}

export type searchContentV1Response400 = {
  data: void
  status: 400
}

export type searchContentV1Response500 = {
  data: void
  status: 500
}

export type searchContentV1Response501 = {
  data: void
  status: 501
}

export type searchContentV1ResponseSuccess = (searchContentV1Response200) & {
  headers: Headers;
};
export type searchContentV1ResponseError = (searchContentV1Response400 | searchContentV1Response500 | searchContentV1Response501) & {
  headers: Headers;
};

export type searchContentV1Response = (searchContentV1ResponseSuccess | searchContentV1ResponseError)

export const getSearchContentV1Url = (instanceId: string,
    params: SearchContentV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/${instanceId}/search?${stringifiedParams}` : `/api/v1/${instanceId}/search`
}

/**
 * Search for content using CMS search index
 */
export const searchContentV1 = async (instanceId: string,
    params: SearchContentV1Params, options?: Parameters<typeof customFetch>[1]): Promise<searchContentV1Response> => {

  return customFetch<searchContentV1Response>(getSearchContentV1Url(instanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type reindexContentV1Response200 = {
  data: void
  status: 200
}

export type reindexContentV1Response500 = {
  data: void
  status: 500
}

export type reindexContentV1Response501 = {
  data: void
  status: 501
}

export type reindexContentV1ResponseSuccess = (reindexContentV1Response200) & {
  headers: Headers;
};
export type reindexContentV1ResponseError = (reindexContentV1Response500 | reindexContentV1Response501) & {
  headers: Headers;
};

export type reindexContentV1Response = (reindexContentV1ResponseSuccess | reindexContentV1ResponseError)

export const getReindexContentV1Url = (instanceId: string,) => {




  return `/api/v1/${instanceId}/search/reindex`
}

/**
 * Triggers a reindex of the CMS content (if supported)
 */
export const reindexContentV1 = async (instanceId: string, options?: Parameters<typeof customFetch>[1]): Promise<reindexContentV1Response> => {

  return customFetch<reindexContentV1Response>(getReindexContentV1Url(instanceId),
  {
    ...options,
    method: 'POST'


  }
);}


export type getTranslationsByCultureV1Response200 = {
  data: TranslationResponse
  status: 200
}

export type getTranslationsByCultureV1Response400 = {
  data: TranslationErrorResponse
  status: 400
}

export type getTranslationsByCultureV1Response404 = {
  data: TranslationErrorResponse
  status: 404
}

export type getTranslationsByCultureV1ResponseSuccess = (getTranslationsByCultureV1Response200) & {
  headers: Headers;
};
export type getTranslationsByCultureV1ResponseError = (getTranslationsByCultureV1Response400 | getTranslationsByCultureV1Response404) & {
  headers: Headers;
};

export type getTranslationsByCultureV1Response = (getTranslationsByCultureV1ResponseSuccess | getTranslationsByCultureV1ResponseError)

export const getGetTranslationsByCultureV1Url = (instanceId: string,
    culture: string,) => {




  return `/api/v1/${instanceId}/translations/${culture}`
}

export const getTranslationsByCultureV1 = async (instanceId: string,
    culture: string, options?: Parameters<typeof customFetch>[1]): Promise<getTranslationsByCultureV1Response> => {

  return customFetch<getTranslationsByCultureV1Response>(getGetTranslationsByCultureV1Url(instanceId,culture),
  {
    ...options,
    method: 'GET'


  }
);}


